import {createTooltipTranslationProviderFromNamespace} from 'features/localizedTooltips/';
import {SUBSCRIPTIONS_TRANSLATION_NAMESPACE} from './subscriptionsConstants';

export const SubscriptionsTooltipTranslationProvider =
	createTooltipTranslationProviderFromNamespace(
		SUBSCRIPTIONS_TRANSLATION_NAMESPACE,
	);
